module.exports = __webpack_public_path__ + "img/login-splash.a8c58a6c.svg";